import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { useTemplateStore } from 'Hooks/zustand/useTemplateStore';
import { getListForListManagement } from 'Services';
import { shouldShowLists } from 'Selectors';
import { RQ_ALL_LIST } from 'Utils';
import { addFormattedProperty, getListIdHashMap } from './util';

function useGetList(users?: UsersHashmap) {
    const { t } = useTranslation();
    const { templateRepositoryId } = useTemplateStore.getState().template;
    const showLists = shouldShowLists();
    // TODO: once we figure out if we are trying to do server side pagination
    // or if we're doing FE pagination, need to change this
    return useQuery(
        [RQ_ALL_LIST],
        () =>
            getListForListManagement({
                perPage: Number.MAX_SAFE_INTEGER,
                page: 1,
                templateRepositoryId: templateRepositoryId!,
                showLists
            }),
        {
            // TODO: potentially move into util.tsx to make reading easier (TBD if it's worth)
            enabled: !!(templateRepositoryId && templateRepositoryId > 0),
            select: (data) => {
                return {
                    ...data,
                    result: data.result.map(addFormattedProperty(t, users)),
                    listIdHashMap: getListIdHashMap(data.result)
                };
            }
        }
    );
}

export default useGetList;
